import i18n from '../i18n';
import {
  TYPE_STUDIO,
  TYPE_SET,
  TYPE_PREP,
  TYPE_ACC_PREP,
  TYPE_POIRIER_SET,
} from '../constants/booking';

export const determineLinkedLocation = (location, mappedLocations) => {
  switch (location.locationTypeId) {
    case TYPE_PREP:
    case TYPE_ACC_PREP:
      return mappedLocations.find(locationOption => locationOption.id === location.mappedToLocationId);
    case TYPE_POIRIER_SET:
    case TYPE_SET:
    case TYPE_STUDIO:
      return mappedLocations.find(locationOption => location.id === locationOption.mappedToLocationId);
    default: 
      return null;
  }
}

export const shouldBeMapped = (locationTypeId) => {
  return locationTypeId === TYPE_PREP || locationTypeId === TYPE_ACC_PREP;
};

export const shouldBeFed = (locationTypeId) => {
  return locationTypeId === TYPE_STUDIO || locationTypeId === TYPE_SET || locationTypeId === TYPE_POIRIER_SET;
}

export const isLocationMappedTo = (location, allLocations) =>
  allLocations.map(locationEntity => locationEntity.mappedToLocationId).includes(location.id);

export const findMappedFromLocationId = (location, allLocations) =>
  allLocations.find(locationEntity => locationEntity.mappedToLocationId === location.id)?.id;

export const formatReactSelectOptionsForMappedFrom = (filteredLocations, currentLocationId) => {
  return filteredLocations.map(location => {
    const isNotActiveWarning = location.isActive ? '' : i18n.t('location:notActive');
    const label = `${location.locationName} ${isNotActiveWarning.toUpperCase()}`;
    return {
      ...location,
      value: location.id,
      label: label.trim(),
      // warn if this location is already mapping to another location
      shouldWarn: location.mappedToLocationId > 0 && location.mappedToLocationId !== currentLocationId,
    }
  });
}

export const formatReactSelectOptionsForMappedTo = (filteredLocations, allLocations, mappedToLocationId) => {
  return filteredLocations.map(location => {
    const isNotActiveWarning = location.isActive ? '' : i18n.t('location:notActive');
    const label = `${location.locationName} ${isNotActiveWarning.toUpperCase()}`;
    return {
      ...location,
      value: location.id,
      label: label.trim(),
      // warn if this location is already being mapped to by another location
      shouldWarn: isLocationMappedTo(location, allLocations) && location.id !== mappedToLocationId,
    }
  })
}

export const groupMappedLocationOptions = (locations, currentLocation) => {
  switch (currentLocation.locationTypeId) {
    case TYPE_ACC_PREP:
      return formatReactSelectOptionsForMappedTo(
        locations.filter(location => location.locationTypeId === TYPE_SET),
        locations,
        currentLocation.mappedToLocationId
      );
    case TYPE_PREP:
      return formatReactSelectOptionsForMappedTo(
        locations.filter(location => location.locationTypeId === TYPE_STUDIO || location.locationTypeId === TYPE_POIRIER_SET),
        locations,
        currentLocation.mappedToLocationId
      );
    case TYPE_POIRIER_SET:
    case TYPE_SET:
      return formatReactSelectOptionsForMappedFrom(
        locations.filter(location => location.locationTypeId === TYPE_ACC_PREP),
        currentLocation.id
      );
    case TYPE_STUDIO:
      return formatReactSelectOptionsForMappedFrom(
        locations.filter(location => location.locationTypeId === TYPE_PREP),
        currentLocation.id
      );
    default:
      return [];
  }
}

export const getDoubleBookingLabel = (position) => {
  const capitalized = position.i18nLabel.charAt(0).toUpperCase() + position.i18nLabel.slice(1)
  return `location:double${capitalized}`
}
  